import varAxios from "../../Comman/axios";
import {GetLifeguardPerformedDefibrillatorCpr,AddUpdateLifeguardPerformedDefibrillatorCpr,GetRegionListUrl,GetAllAlarmRulesUrl,UpdateAlarmRuleUrl} from '../../Comman/apiEndPoints';

export const Fetch_All_Alarm_Rules_Data = "Fetch_All_Alarm_Rules_Data";
export const Update_Alarm_Rule_Success = "Update_Alarm_Rule_Success";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";

export const Fetch_All_AddUpdateLifeguardPerformedDefibrillatorCpr_Data = "Fetch_All_AddUpdateLifeguardPerformedDefibrillatorCpr_Data";
export const Update_AddUpdateLifeguardPerformedDefibrillatorCpr_Success = "Update_AddUpdateLifeguardPerformedDefibrillatorCpr_Success";
export function getAllAlarmRules(RegionId) {
    return(dispatch) =>{
       return varAxios.post(GetAllAlarmRulesUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
          dispatch(
            fetchAllAlarmRulesData({
                errorCode : response.data.errorCode,
                statusCode : response.data.statusCode,
                alarmRules : response.data.AlarmRules
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllAlarmRulesData({errorCode,statusCode,alarmRules}) {
    return{
        type : Fetch_All_Alarm_Rules_Data,
        errorCode,
        statusCode,
        alarmRules
    }
}
export function updateAlarmRuleSuccess(errorCode,statusCode,message,list) {
    return {
        type : Update_Alarm_Rule_Success,
        errorCode,
        statusCode,
        message,
        list
    }
}
export function editAlarmRule(data) {
    return (dispatch) => {
        return varAxios.post(UpdateAlarmRuleUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                  updateAlarmRuleSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.Message,response.data.List)
                );
                this.getAllAlarmRules({RegionId:data.RegionId})
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
    export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
      
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
               this.getAllAlarmRules({RegionId:response.data.regionList[0].ID});
              return Promise.resolve(response.data);
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}
  export function getLifeguardPerformedDefibrillatorCpr1(RegionId) {
    debugger
    return(dispatch) =>{
       return varAxios.post(GetLifeguardPerformedDefibrillatorCpr,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
          dispatch(
            fetchGetLifeguardPerformedDefibrillatorCprData({
                errorCode : response.data.errorCode,
                statusCode : response.data.statusCode,
                lifeguardPerformedDefibrillator : response.data.lifeguardPerformedDefibrillator
             }));
              return Promise.resolve(response.data);
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchGetLifeguardPerformedDefibrillatorCprData({errorCode,statusCode,lifeguardPerformedDefibrillator}) {
    return{
        type : Fetch_All_AddUpdateLifeguardPerformedDefibrillatorCpr_Data,
        errorCode,
        statusCode,
        lifeguardPerformedDefibrillator
    }
}
export function updateGetLifeguardPerformedDefibrillatorCprSuccess(errorCode,statusCode,message,lifeguardPerformedDefibrillator) {
    return {
        type :Update_AddUpdateLifeguardPerformedDefibrillatorCpr_Success,
        errorCode,
        statusCode,
        message,
        lifeguardPerformedDefibrillator
    }
}
export function editGetLifeguardPerformedDefibrillatorCpr(data) {
    return (dispatch) => {
        return varAxios.post(AddUpdateLifeguardPerformedDefibrillatorCpr, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                  updateGetLifeguardPerformedDefibrillatorCprSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.Message,response.data.lifeguardPerformedDefibrillator)
                );
                 return Promise.resolve(response.data);
               // this.getGetLifeguardPerformedDefibrillatorCpr({RegionId:data.RegionId})
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }